import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";
import {SET_PAGINATE} from "./paginate.module";

// action types
export const ADD_USER = "addUser";
export const GET_USERS = "getUsers";
export const GET_USER_DETAILS = "getUserDetails";
export const UPDATE_USER_DETAILS = "updateUserDetails";
export const UPDATE_USER_PASSWORD = "updateUserPassword";
export const DELETE_USER = "deleteUser";
export const GET_ROLES = "getRoles";


// mutation types
export const SET_USERS_ERROR = "setErrorsUser";
export const SET_USERS = "setUsers";
export const SET_USER = "setUser";
export const SET_USER_EDIT = "setUserEdit";
export const SET_USER_LOAD = "setUserLoad";
export const SET_ROLES = "setRoles";

const state = {
    errors: {},
    users: [],
    roles: [],
    load: true,
    user: {},
    userEdit: {
        image: '',
        name: '',
        email: '',
        password: '',
        password_confirmation: '',
        roles: [],
    },

};


const getters = {
    gettersUsers(state) {
        return state.users;
    },
    gettersUser(state) {
        return state.user;
    },
    gettersUserEdit(state) {
        return state.userEdit;
    },
    gettersRoles(state) {
        return state.roles;
    },
    errorsUsers(){
        return state.errors;
    },
    getUserLoad(){
        return state.load;
    },
};

const actions = {

    [ADD_USER](context, data){
        return new Promise((resolve, reject) => {
            context.commit(SET_USERS_ERROR, {});
            ApiService.post("/user/store", data)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                    if (response.status === 422){
                        context.commit(SET_USERS_ERROR, response.data.errors);
                    }
                });
        });
    },


    [GET_USERS](context, data) {

        return new Promise((resolve, reject) => {
            context.commit(SET_USER_LOAD, true);
            ApiService.post("/users", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_USERS, data);
                    context.commit(SET_PAGINATE, data);
                    context.commit(SET_USER_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_USERS_ERROR, response.data.errors);
                    context.commit(SET_USER_LOAD, false);
                });
        });
    },


    [GET_ROLES](context){
        return new Promise((resolve, reject) => {
            ApiService.get("/roles")
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_ROLES, data);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_USERS_ERROR, response.data.errors);
                });
        });
    },

    [GET_USER_DETAILS](context, id) {
        context.commit(SET_USER_LOAD, true);
        ApiService.get("/edit-user", id)
            .then(({ data }) => {
                context.commit(SET_USER_EDIT, data);
                context.commit(SET_USER_LOAD, false);
            })
            .catch(({ response }) => {
                context.commit(SET_USERS_ERROR, response.data.errors);
                context.commit(SET_USER_LOAD, false);
            });
    },

    [UPDATE_USER_DETAILS](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_USERS_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.update("/user-details/update", data.id, data.user)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_USERS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_USERS_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },

    [DELETE_USER](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/user/destroy", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_USERS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

    [UPDATE_USER_PASSWORD](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_USERS_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.update("/user-details/change-password", data.id, data.password)
                    .then(({ data }) => {
                        context.commit(SET_USERS_ERROR, {});
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        if (response.status === 422){
                            context.commit(SET_USERS_ERROR, response.data.errors);
                        }
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },

};

const mutations = {
    [SET_USERS_ERROR](state, error) {
        state.errors = error;
    },

    [SET_USERS](state, data) {
        state.users = data.data;
    },

    [SET_ROLES](state, roles) {
        state.roles = roles;
    },

    [SET_USER](state, product) {
        state.user = product.user;
    },


    [SET_USER_EDIT](state, user) {
        state.userEdit = user.user;
    },



    [SET_USER_LOAD](state, load) {
        state.load = load;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
